import React, { Component } from 'react';
import { connect } from 'react-redux';
import EditDealershipSettings from '../../inputs/EditDealershipSettings';
import EditDealershipSettingsWithDealership from '../../inputs/EditDealershipSettingsWithDealership';
import EditInstallation from '../../inputs/EditInstallation';
import DropBoxDealer from '../../inputs/FileUploadButton/DropBoxDealer';
import GroupSettingsBody from './GroupSettingsBody';

class GroupSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value1: this.props.override_value_1, current_default_profile: this.props.current_default_profile, errors: { addDepartmentPropertyError: false }, option_name: '',
		};
	}

	dealerSettingValue(name) {
		const self = this;

		const value = _.sortBy(_.filter(self.props.dealer_settings, o => o.key === name), 'id');
		if (value.length > 0) {
			if (typeof (value[0]) !== undefined && typeof (value[0].value) !== undefined) {
				return value[0].value;
			}
		} else {
			return '';
		}
	}

	dealerSettingValueDealership(name) {
		const self = this;

		const value = _.sortBy(_.filter(self.props.dealer_settings, o => o.key === name && o.dealership === self.props.installation.subdomain), 'id');
		if (value.length > 0) {
			if (typeof (value[0]) !== undefined && typeof (value[0].value) !== undefined) {
				return value[0].value;
			}
		} else {
			return '';
		}
	}
	

	render() {
		const { installation } = this.props;
		return (
			<div className="row pad-left-2 pad-right-2 space-left-2 space-right-2">
								<GroupSettingsBody />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		dealer_settings: state.settings_site.dealer_settings,
		installation: state.settings_dealerships.installation,
	};
}
export default connect(mapStateToProps)(GroupSettings);
